import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import DefaultLayout from "layouts/default.jsx";

import { Helmet } from 'react-helmet'

import PictureHero from "components/PictureHero/PictureHero.jsx";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Banner from "components/Banner/Banner.jsx";
import Avatar from "@material-ui/core/Avatar";
import HeroCard from "components/HeroCard/HeroCard.jsx";
import Quote from "components/Quote/Quote.jsx";
import JoinModal from "components/JoinModal/JoinModal.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import WaitlistCTA from "sections/CTAs/WaitlistCTA.jsx";

import Columns from "components/Background/Columns.jsx";
import Votes from "components/Background/Votes.jsx";
import RunningAcrossBridge from "components/Background/RunningAcrossBridge.jsx";

import votingFundsHeaderHero from "data/voting-funds-header-hero.json";
import votingFundsAltHero from "data/voting-funds-alt.json";
import votingFundsInvestmentHero from "data/voting-funds-investments-hero.json";

import athenaLogo from "assets/img/athena-white.svg";
import quotes from "data/quotes.json";
import votingfundsImage from "assets/img/votingfunds.png";

const Logo = (props) => {
  const {classes, ...rest } = props;
  return <Avatar src={athenaLogo} className={classNames(classes.votingFundsLogo, classes.productLogo)} />
};

class VotingFundsPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <DefaultLayout>
        <Helmet>
          <title>voting funds | we the shareholders</title>
          <meta property="og:title" content="voting funds | we the shareholders"/>
          <meta name="twitter:title" content="voting funds | we the shareholders"/>
          <meta name="description" content="Once realized, Voting Funds will be the first-ever voting-pass-through family of mutual funds and ETFs."/>
          <meta property="og:description" content="Once realized, Voting Funds will be the first-ever voting-pass-through family of mutual funds and ETFs."/>
          <meta name="twitter:description" content="Once realized, Voting Funds will be the first-ever voting-pass-through family of mutual funds and ETFs."/>
          <meta property="og:image" content={`https://wetheshareholders.com${votingfundsImage}`}/>
          <meta name="twitter:image" content={`https://wetheshareholders.com${votingfundsImage}`}/>
          <meta property="og:image:alt" content="A set of classical style columns."/>
          <meta name="twitter:image:alt" content="A set of classical style columns."/>
        </Helmet>
        <Banner filter={true} BackgroundImage={Columns}>
          <div className={classNames(classes.container)}>
            <GridContainer alignContent="space-around" alignItems="center" justify="center">
              <GridItem xs={5} md={4} lg={3}>
              <Logo classes={classes}/>
              </GridItem>
              <GridItem xs={12} lg={8} className={classes.noGutter}>
              <h1 className={classNames(classes.votingFundsBrandLarge, classes.productBrand)}>voting funds
              <br/>
              <small className={classNames(classes.votingFundsSloganLarge, classes.productBrand)}>change corporations. change the world.</small>
              </h1>
              </GridItem>
            </GridContainer>
          </div>
        </Banner>
          <GridContainer alignItems="center">
          </GridContainer>
        <div className={classNames(classes.main)}>
          <div className={classNames(classes.greyBackground)}>
            <div className={classes.waitlistBar}>
              <JoinModal fullWidthButton buttonText="Coming Soon. Join our waitlist."  listIds={[22, 30]}/>
            </div>
            <HeroCard className={classes.productHeaderHeroCard} hero={votingFundsHeaderHero}/>
            <PictureHero BackgroundImage={Votes} imageLeft hero={votingFundsAltHero}/>
            <PictureHero id="" BackgroundImage={RunningAcrossBridge} imageRight hero={votingFundsInvestmentHero}/>
            <GridContainer justify="center">
              <GridItem sx={12} sm={10} md={8}>
                <Quote plain quote={quotes.strineTwo}/>
              </GridItem>
            </GridContainer>
            <WaitlistCTA  listIds={[14]}/>
          </div>
        </div>
        <Footer />
      </DefaultLayout>
    );
  }
}

export default withStyles(landingPageStyle)(VotingFundsPage);
